const handleLog = ' %c';

export const INFO = `%c☉${handleLog}`;
export const SUCCESS = `%c☀${handleLog}`;
export const WARNING = `%c☂${handleLog}`;
export const ERROR = `%c❄${handleLog}`;
export const REQUEST = `%c⇄${handleLog}`;
